import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  Dimensions,
} from "react-native";
import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";

import TransportInactive from "./TransportInactive";
import TransportActive from "./TransportActive";
import TransportAll from "./TransportAll";

const { width } = Dimensions.get("window");

// Custom Tab Bar Component
const CustomTabBar = ({ state, descriptors, navigation, position }) => {
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  // Tab configuration
  const tabs = [
    {
      key: "all",
      title: t("common:translation.All"),
      component: TransportAll,
    },
    {
      key: "active",
      title: t("common:translation.Active"),
      component: TransportActive,
    },
    {
      key: "inactive",
      title: t("common:translation.History"),
      component: TransportInactive,
    },
  ];

  return (
    <View style={styles.tabBarContainer}>
      <View style={styles.tabBar}>
        {tabs.map((tab, index) => {
          const isFocused = state.index === index;

          const onPress = () => {
            const event = navigation.emit({
              type: "tabPress",
              target: tab.key,
              canPreventDefault: true,
            });

            if (!isFocused && !event.defaultPrevented) {
              navigation.navigate(tab.key);
            }
          };

          return (
            <TouchableOpacity
              key={tab.key}
              accessibilityRole="button"
              accessibilityState={isFocused ? { selected: true } : {}}
              onPress={onPress}
              style={[styles.tab, isFocused && styles.activeTab]}
              activeOpacity={0.7}
            >
              <Text
                style={[styles.tabLabel, isFocused && styles.activeTabLabel]}
              >
                {tab.title}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>

      {/* Animated Indicator */}
      <View style={styles.indicatorContainer}>
        <View
          style={[
            styles.indicator,
            {
              width: width / tabs.length,
              transform: [{ translateX: (width / tabs.length) * state.index }],
            },
          ]}
        />
      </View>
    </View>
  );
};

// Custom Tab Navigator Component
const CustomTabNavigator = ({ navigation }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  const tabs = [
    {
      key: "all",
      title: t("common:translation.All"),
      component: TransportAll,
    },
    {
      key: "active",
      title: t("common:translation.Active"),
      component: TransportActive,
    },
    {
      key: "inactive",
      title: t("common:translation.History"),
      component: TransportInactive,
    },
  ];

  const ActiveComponent = tabs[activeIndex].component;

  return (
    <>
      <CustomTabBar
        state={{ index: activeIndex }}
        navigation={{
          navigate: (key) => {
            const index = tabs.findIndex((tab) => tab.key === key);
            if (index !== -1) {
              setActiveIndex(index);
            }
          },
          emit: () => ({ defaultPrevented: false }),
        }}
      />
      <View style={styles.contentContainer}>
        <ActiveComponent />
      </View>
    </>
  );
};

const TransportManager = ({ navigation }) => {
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={styles.backIcon} />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>
            {t("common:translation.Transport Manager")}
          </Text>
        </View>

        <View style={styles.headerRight}>
          <TouchableOpacity
            style={styles.iconButton}
            onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}
          >
            <Image
              source={AppImages.Bellnoti}
              style={styles.notificationIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.iconButton}
            onPress={() => navigation.navigate("AddTransportManager")}
          >
            <Image
              source={AppImages.Plus}
              style={styles.plusIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      {/* Custom Tab Navigator */}
      <View style={{ flex: 1, marginTop: 20 }}>
        <CustomTabNavigator navigation={navigation} />
      </View>
    </SafeAreaView>
  );
};

export default TransportManager;

const styles = StyleSheet.create({
  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 5,
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    height: 30,
    width: 30,
    justifyContent: "center",
  },
  backIcon: {
    width: 8,
    height: 15,
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    marginLeft: 15,
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  iconButton: {
    padding: 5,
  },
  notificationIcon: {
    width: 16,
    height: 20,
  },
  plusIcon: {
    width: 18,
    height: 18,
    marginLeft: 15,
  },

  // Custom Tab Bar Styles
  tabBarContainer: {
    backgroundColor: AppColors.white,
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  tabBar: {
    flexDirection: "row",
    backgroundColor: "#F5F5F5",
    borderRadius: 8,
    padding: 4,
  },
  tab: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 10,
    borderRadius: 6,
  },
  activeTab: {
    backgroundColor: AppColors.white,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  tabLabel: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: "#9C4900CC",
  },
  activeTabLabel: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  indicatorContainer: {
    height: 3,
    marginTop: 8,
  },
  indicator: {
    height: 3,
    backgroundColor: "#8F4300",
    borderRadius: 1.5,
  },
  contentContainer: {
    flex: 1,
    backgroundColor: AppColors.sandal,
  },
});
